import React from 'react';
import { useTranslation } from 'react-i18next';
import { UploadFile, Upload, RcFile } from 'antd';
import { CloudUploadOutlined } from 'antd/icons';
import styled from '@emotion/styled';

const Dragger = styled(Upload.Dragger)`
  & > span:focus-visible {
    outline-color: var(--ant-primary-5);
    outline-style: auto;
  }
`;

const UploadDocumentDragger = ({
  shouldFileBeUploadedImmediately = false,
  files,
  setFiles,
  customRequest = () => {},
  isFile = false,
  disabled = false
}: {
  shouldFileBeUploadedImmediately?: boolean;
  files: UploadFile[];
  setFiles: React.Dispatch<React.SetStateAction<UploadFile[]>>;
  customRequest?: (file: UploadFile) => void;
  isFile?: boolean;
  disabled?: boolean;
}) => {
  const { t } = useTranslation('common');
  return (
    <Dragger
      disabled={disabled}
      multiple
      customRequest={({ file }) => {
        const extendedFile = files.find(({ uid }) => (file as RcFile).uid === uid);
        if (extendedFile) customRequest(extendedFile);
      }}
      fileList={files}
      onChange={(e) => {
        e.file.status = shouldFileBeUploadedImmediately ? 'uploading' : 'done';
        setFiles(e.fileList);
      }}
    >
      <CloudUploadOutlined
        aria-hidden
        style={{ fontSize: '48px', color: disabled ? 'rgba(0, 0, 0, 0.45)' : 'var(--ant-primary-5)' }}
      />

      <p style={{ margin: '20px 0 4px', color: 'rgba(0, 0, 0, 0.85)', fontSize: '16px' }}>
        {isFile ? t('Upload these files?') : t('Drag & Drop')}
      </p>
      <p style={{ color: 'rgba(0, 0, 0, 0.45)', fontSize: '14px' }}>
        {isFile ? (
          <>
            {t('Click')}{' '}
            <strong>
              <u>{t('here')}</u>
            </strong>{' '}
            {t('to upload more')}
          </>
        ) : (
          <>
            {t('Your files here or click')}{' '}
            <strong>
              <u>{t('here')}</u>
            </strong>{' '}
            {t('to upload')}
          </>
        )}
      </p>
    </Dragger>
  );
};

export default UploadDocumentDragger;
